// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionPublishAPI, publishAPIError, publishAPISuccess } from './actions';
import { PublishResult } from './types';

import { createAPINetworkInstance } from 'common/api';
import { parseAPIPublishResult } from './utils';

function* publish(action: ActionPublishAPI) {
    try {
        const { idengine, iddealer, syncType } = action
        const { data } = yield call(createAPINetworkInstance().post, `engine/${idengine}/dealer/${iddealer}/publish/type/${syncType}`);
        const result: PublishResult = parseAPIPublishResult(data);
        yield put(publishAPISuccess(result));
    } catch (err) {
        yield put(publishAPIError());
    }
}

export default function* publishSagas() {
    yield takeLatest(ACTIONS.PUBLISH_API_REQUEST, publish);
}